
/* injects from baggage-loader */

'use strict';

export default function (app) {

	// NOTE: TEMPALTE REPLACEMENT HANDLED BY WEBPACK, DON'T EDIT MANUALLY
	// Default page name displayed in the browser tab
	app.constant('DEFAULT_PAGE_TITLE', 'Neighbor Funds');

	// NOTE: TEMPALTE REPLACEMENT HANDLED BY WEBPACK, DON'T EDIT MANUALLY
	// Map tile server
	app.constant('MAP_TILE_SERVER', 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}');

	// Stripe constants
	app.constant('STRIPE_REDIRECT_URI', 'https://api.neighborfunds.com/account/settings/connected-accounts');
	app.constant('STRIPE_CLIENT_ID', 'ca_D2SRo79K31zJOwCqhHqaueycIDncoDYV');
	
}


// WEBPACK FOOTER //
// ./src/app/core/constants.js